import type { Era, UpgradeDef } from './types';

export const ERAS: Era[] = [
  {
    id: 'void',
    name: 'Primordial Void',
    description: 'A shapeless expanse of potential. Click to awaken it.',
    requiredEnergy: 0,
    icon: '🌌',
    orbGradient: 'radial-gradient(circle at 40% 35%, #6b7280, #111827)',
    glowColor: 'rgba(107, 114, 128, 0.4)',
  },
  {
    id: 'primal',
    name: 'Primal World',
    description: 'Molten rock and volcanic fury shape the young world.',
    requiredEnergy: 500,
    icon: '🌋',
    orbGradient: 'radial-gradient(circle at 40% 35%, #f97316, #7f1d1d)',
    glowColor: 'rgba(249, 115, 22, 0.5)',
  },
  {
    id: 'life',
    name: 'Age of Life',
    description: 'Simple organisms emerge from the primordial seas.',
    requiredEnergy: 10000,
    icon: '🌍',
    orbGradient: 'radial-gradient(circle at 40% 35%, #4ade80, #1e3a5f)',
    glowColor: 'rgba(74, 222, 128, 0.5)',
  },
  {
    id: 'ancient',
    name: 'Ancient Civilizations',
    description: 'Intelligent beings erect their first great monuments.',
    requiredEnergy: 200000,
    icon: '🏛️',
    orbGradient: 'radial-gradient(circle at 40% 35%, #fbbf24, #78350f)',
    glowColor: 'rgba(251, 191, 36, 0.5)',
  },
  {
    id: 'industrial',
    name: 'Industrial Age',
    description: 'Steam, steel, and electricity reshape the world.',
    requiredEnergy: 5000000,
    icon: '🏭',
    orbGradient: 'radial-gradient(circle at 40% 35%, #94a3b8, #1e293b)',
    glowColor: 'rgba(148, 163, 184, 0.5)',
  },
  {
    id: 'space',
    name: 'Space Age',
    description: 'Your world reaches beyond its atmosphere to touch the stars.',
    requiredEnergy: 100000000,
    icon: '🚀',
    orbGradient: 'radial-gradient(circle at 40% 35%, #a78bfa, #1e1b4b)',
    glowColor: 'rgba(167, 139, 250, 0.6)',
  },
];

export const UPGRADE_DEFS: UpgradeDef[] = [
  {
    id: 'spark',
    name: 'Spark',
    description: 'A tiny pulse of energy from the void.',
    baseCost: 10,
    baseProduction: 0.1,
    minEraIndex: 0,
    icon: '⚡',
  },
  {
    id: 'ember',
    name: 'Ember',
    description: 'A smoldering fragment of primal heat.',
    baseCost: 80,
    baseProduction: 0.5,
    minEraIndex: 0,
    icon: '🔥',
  },
  {
    id: 'vent',
    name: 'Volcanic Vent',
    description: 'Channels geothermal energy from deep below.',
    baseCost: 500,
    baseProduction: 4,
    minEraIndex: 1,
    icon: '🌋',
  },
  {
    id: 'tide',
    name: 'Tidal Current',
    description: 'Harnesses the rhythmic power of the seas.',
    baseCost: 3000,
    baseProduction: 20,
    minEraIndex: 1,
    icon: '🌊',
  },
  {
    id: 'forest',
    name: 'Ancient Forest',
    description: 'Living trees pulse with organic energy.',
    baseCost: 15000,
    baseProduction: 100,
    minEraIndex: 2,
    icon: '🌲',
  },
  {
    id: 'creature',
    name: 'Living Creature',
    description: 'Complex life generates tremendous biological energy.',
    baseCost: 100000,
    baseProduction: 600,
    minEraIndex: 2,
    icon: '🦕',
  },
  {
    id: 'settlement',
    name: 'Settlement',
    description: 'Gathered communities amplify collective energy.',
    baseCost: 600000,
    baseProduction: 4000,
    minEraIndex: 3,
    icon: '🏘️',
  },
  {
    id: 'monument',
    name: 'Great Monument',
    description: 'Massive stone structures channel cosmic energies.',
    baseCost: 4000000,
    baseProduction: 25000,
    minEraIndex: 3,
    icon: '🏛️',
  },
  {
    id: 'engine',
    name: 'Steam Engine',
    description: 'Industrial machinery multiplies energy output.',
    baseCost: 25000000,
    baseProduction: 175000,
    minEraIndex: 4,
    icon: '⚙️',
  },
  {
    id: 'generator',
    name: 'Power Generator',
    description: 'Vast electrical grids power the industrial world.',
    baseCost: 200000000,
    baseProduction: 1200000,
    minEraIndex: 4,
    icon: '🔋',
  },
  {
    id: 'satellite',
    name: 'Orbital Satellite',
    description: 'Space-based solar collectors harvest stellar energy.',
    baseCost: 1500000000,
    baseProduction: 9000000,
    minEraIndex: 5,
    icon: '🛸',
  },
];
